import { ApiUrl,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import { fromJS } from 'immutable';
import doFetch from '../../../infra/helper/fetchHelper'

export default (formBody) => async (dispatch) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });
    
    let formdata = new FormData();
    
    var param = fromJS(formBody.data);
    param.map((k,v) => {
        formdata.append(v,k);    
    });
    
    const url = ApiUrl+'user-create-account';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': 'Bearer ' + UserToken,
        },
        body: formdata
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};